import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Paper, Tabs, Tab, Stack, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardLayout from "../../../layouts/DashboardLayout";
import SearchBar from "../../requerimiento/components/SearchBar";
import BusquedasRecientes, { useBusquedasRecientes } from "../../requerimiento/components/BusquedasRecientes";
import { useClientesYEquipos } from "../../requerimiento/hooks/useClientesYEquipos";
import TablaClientesOT from "../components/TablaClientesOT";
import TablaOrdenesTrabajo from "../components/TablaOrdenesTrabajo";
import HistorialCliente from "../../historialCliente/pages/HistorialCliente";

const a11yProps = (index) => ({ id: `ot-tab-${index}`, "aria-controls": `ot-tabpanel-${index}` });

const BuscarClienteOrdenTrabajo = () => {
  const [searchParams] = useSearchParams();
  // ?tab= llega de accesos directos (ej. "Mis OT pendientes" del dashboard,
  // que abre directo en la pestaña 2) para no arrancar siempre en búsqueda.
  const [tab, setTab] = useState(() => {
    const t = parseInt(searchParams.get("tab"), 10);
    return [0, 1, 2].includes(t) ? t : 0;
  });
  const [view0, setView0] = useState("list"); // "list" | "historial"
  const [histCli, setHistCli] = useState(null);

  const openHistorial = (cli) => {
    setHistCli(cli);
    setView0("historial");
  };

  const backToList = () => {
    setHistCli(null);
    setView0("list");
  };

  const {
    clientes,
    equiposMap,
    servicios,
    loadingServicios,
    searching,
    searchPerformed,
    page,
    rowsPerPage,
    totalClientes,
    search,
    changePage,
    changeRowsPerPage,
  } = useClientesYEquipos({ excluirServicio: "AVL,Scada" });

  const { recientes, precargar, buscar, repetir, quitar, limpiar } = useBusquedasRecientes("ot_busquedas_recientes", search);

  return (
    <DashboardLayout>
      <Box sx={{ width: "100%" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Órdenes de Trabajo</Typography>

        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ minHeight: 34, "& .MuiTab-root": { minHeight: 34, py: 0.5, fontSize: 12, fontWeight: 700, textTransform: "none" } }}
          >
            <Tab label="Emitir O.T." {...a11yProps(0)} />
            <Tab label="Órdenes de Trabajo" {...a11yProps(1)} />
            <Tab label="Mis Pendientes" {...a11yProps(2)} />
          </Tabs>
        </Paper>

        {tab === 0 && (
          view0 === "list" ? (
            <>
              <SearchBar
                onSearch={buscar}
                precargar={precargar}
                searching={searching}
                servicios={servicios}
                loadingServicios={loadingServicios}
                excludeServicioNombre="AVL,Scada"
              />

              {!searchPerformed ? (
                <BusquedasRecientes titulo="Busca un cliente para emitir su O.T." recientes={recientes} servicios={servicios} onRepetir={repetir} onQuitar={quitar} onLimpiar={limpiar} />
              ) : searching ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} />
                  <Typography>Buscando datos…</Typography>
                </Box>
              ) : (
                <TablaClientesOT
                  clientes={clientes}
                  equiposMap={equiposMap}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  total={totalClientes}
                  onPageChange={changePage}
                  onRowsPerPageChange={changeRowsPerPage}
                  onOpenHistorial={openHistorial}
                />
              )}
            </>
          ) : (
            <Box>
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                <IconButton onClick={backToList} title="Volver">
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6">
                  Historial — {histCli?.nombre_cliente || ""} ({histCli?.cod_servicio_cliente || ""})
                </Typography>
              </Stack>

              <HistorialCliente
                codServicioClienteProp={histCli?.cod_servicio_cliente}
                embedded
                onBack={backToList}
              />
            </Box>
          )
        )}

        {tab === 1 && <TablaOrdenesTrabajo />}
        {tab === 2 && <TablaOrdenesTrabajo defaultSoloMias ocultarCheckboxMias />}
      </Box>
    </DashboardLayout>
  );
};

export default BuscarClienteOrdenTrabajo;
